module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_7016.70e4bdae.png";